"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pronunciationWordSpans = pronunciationWordSpans;
/** Keep reference punctuation and CJK spacing while aligning Azure's assessed words. */
function pronunciationWordSpans(reference, words) {
    if (words.length &&
        words.every((word) => word.textOffset !== undefined && word.textLength !== undefined)) {
        const result = [];
        let cursor = 0;
        words.forEach((word, wordIndex) => {
            const start = word.textOffset, end = start + word.textLength;
            if (start < cursor || end > reference.length || start < 0)
                return;
            if (start > cursor)
                result.push({ text: reference.slice(cursor, start), wordIndex: null });
            const text = reference.slice(start, end);
            for (const part of text.matchAll(/[\p{L}\p{M}\p{N}]+|[^\p{L}\p{M}\p{N}]+/gu))
                result.push({
                    text: part[0],
                    wordIndex: /^[\p{L}\p{M}\p{N}]/u.test(part[0]) ? wordIndex : null,
                });
            cursor = end;
        });
        if (cursor < reference.length)
            result.push({ text: reference.slice(cursor), wordIndex: null });
        return result;
    }
    const positions = [];
    let normalized = "";
    let offset = 0;
    const normalize = (text) => text
        .toLowerCase()
        .normalize("NFD")
        .replace(/\p{M}+/gu, "")
        .replace(/[^\p{L}\p{N}]+/gu, "");
    for (const character of reference) {
        const value = normalize(character);
        normalized += value;
        for (let index = 0; index < value.length; index++)
            positions.push({ start: offset, end: offset + character.length });
        offset += character.length;
    }
    const spans = [];
    let normalizedCursor = 0, cursor = 0;
    words.forEach((word, wordIndex) => {
        if (word.errorType === "Insertion")
            return;
        const value = normalize(word.word);
        if (!value)
            return;
        const position = normalized.indexOf(value, normalizedCursor);
        if (position < 0)
            return;
        const start = positions[position].start, end = positions[position + value.length - 1].end;
        if (start > cursor)
            spans.push({ text: reference.slice(cursor, start), wordIndex: null });
        for (const part of reference
            .slice(start, end)
            .matchAll(/[\p{L}\p{M}\p{N}]+|[^\p{L}\p{M}\p{N}]+/gu))
            spans.push({
                text: part[0],
                wordIndex: /^[\p{L}\p{M}\p{N}]/u.test(part[0]) ? wordIndex : null,
            });
        cursor = end;
        normalizedCursor = position + value.length;
    });
    if (cursor < reference.length)
        spans.push({ text: reference.slice(cursor), wordIndex: null });
    return spans;
}
//# sourceMappingURL=pronunciationWordSpans.js.map